import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-picedit",
  "use": "icon-picedit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-picedit\"><defs><style type=\"text/css\"></style></defs><path d=\"M642.5 158.3c37.8-43.1 103.3-47.4 146.4-9.6s47.4 103.3 9.6 146.4c-3.7 4.3-7.8 8.2-12.2 11.8l-71 71-146.7-146.8 73.4-73.4 0.5 0.6z m-294 586.3v0.1H201.8V597.9h0.1L532 267.8l146.7 146.8-330.2 330z m-198.6 52.7h726.2c28.6 0 51.9 23.2 51.9 51.9 0 28.6-23.2 51.9-51.9 51.9H149.9c-28.6 0-51.9-23.2-51.9-51.9s23.2-51.9 51.9-51.9z\" p-id=\"37244\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/picedit.svg
// module id = G9G0
// module chunks = 22